import type {UpdateProjectItemFieldValue} from '../../../mutations/update-project-item-field-value'
import styles from './Shared.module.css'

export function getTokenStyle(input: string, withIcon?: boolean) {
  return withIcon ? styles.truncatedTokenWithIcon : styles.truncatedTokenNoIcon
}

export type BaseFieldProps<TField, TValue> = {
  viewerCanUpdate: boolean
  onIssueUpdate: () => void
  onUpdateFieldValue: UpdateProjectItemFieldValue
  itemId: string
  projectId: string
  field: TField
  value: TValue | null
  isStatusField?: boolean
}

export type ClearableFieldProps<TField, TValue> = BaseFieldProps<TField, TValue> & {
  onClearFieldValue: (fieldId: string) => void
}
